import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TermsService} from 'src/app/services/terms';

@Component({
  selector: 'acceptance-terms',
  styleUrls: ['./acceptance-terms.component.scss'],
  providers: [TermsService],
  template: `
    <div class='acceptance-terms'>
      <p>
        Nós nos preocupamos com a segurança dos seus dados, por isso adotamos as diretrizes de transparência
        e conformidade com as obrigações previstas na <b>Lei Geral de Proteção de Dados</b> e demais legislações.
      </p>

      <div class='input-group'
           [tooltip]="toolTipDescription"
           [placement]="'bottom'"
           [show-delay]="10"
      >
        <input
          type='checkbox'
          id='term-acceptance'
          [disabled]="disabled"
          [checked]="checked"
          (change)='checkedChange.emit($event.target.checked)'
        >
        <label for='term-acceptance'>
          Eu li e <b>estou de acordo</b> com os
          <a
            *ngIf="accountType === 'establishment'"
            target='_blank'
            href="https://privacidade.allya.com.br/contrato-de-parceria">
            Contrato de Parceria
          </a>
          <a
            *ngIf="accountType === 'company'"
            target='_blank'
            href="https://privacidade.allya.com.br/termos-de-uso">
            Termos de Uso
          </a>
          e a <a target='_blank' href='https://privacidade.allya.com.br/politica-de-privacidade'>Política de
          Privacidade</a> da Allya
        </label>
      </div>

      <div class='warning-box' *ngIf='showAlert'>
        <img src='./assets/shared/img/alert.png' alt='Alert Icon'>

        <span>
          Antes de prosseguir, precisamos que você leia e esteja de acordo com os
          <a
            *ngIf="accountType === 'establishment'"
            target='_blank'
            href="https://privacidade.allya.com.br/contrato-de-parceria">
             Contrato de Parceria
          </a>
          <a
            *ngIf="accountType === 'company'"
            target='_blank'
            href="https://privacidade.allya.com.br/termos-de-uso">
             Termos de Uso
          </a>
           e a <a target='_blank'
                 href='https://privacidade.allya.com.br/politica-de-privacidade'>Política de Privacidade</a>.
        </span>
      </div>
    </div>
  `,
})
export class AcceptanceTermsComponent implements OnInit {

  @Output() checkedChange = new EventEmitter<boolean>();

  @Input() showAlert = false;

  @Input() checked = false;

  @Input() accountType: string;

  toolTipDescription: string;

  disabled = true;

  constructor(
    private termsService: TermsService
  ) {
  }

  async ngOnInit() {
    await this.validateTerms();
  }

  async validateTerms() {
    const termsToAccept = await this.termsService.getTermsToAccept();

    if (termsToAccept.length) {
      this.disabled = false;
      this.toolTipDescription = 'Aceite os termos para continuar';
    } else {
      this.checkedChange.emit(true);
      this.disabled = true;
      this.toolTipDescription = 'Você já aceitou todos os termos!';
    }
  }
}
